import { render, staticRenderFns } from "./SubmissionEditModal.vue?vue&type=template&id=a981fcc4&scoped=true"
import script from "./SubmissionEditModal.vue?vue&type=script&lang=js"
export * from "./SubmissionEditModal.vue?vue&type=script&lang=js"
import style0 from "./SubmissionEditModal.vue?vue&type=style&index=0&id=a981fcc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a981fcc4",
  null
  
)

export default component.exports